import React, {useState, useEffect} from "react"
import API from "../../Services/BaseService";
import { useSelector } from 'react-redux';

const StateAndCityRegistration = props => {
   
    const [defaultZipcodeValue, setDefaultZipcodeValue] = useState(props.defaultZipcodeValue);
    const sellerDetails = useSelector(state => state.LoginReducer.payload);
    const [zipCodeId, setZipCodeId] = useState( null );
    const [isEdit] = useState(props?.isEdit || false);
    const [country, setCountry] = useState("");
    const [defaultStateValue, setDefaultStateValue] = useState(props.defaultStateValue);
    const [stateName, setStateName] = useState(null);
    const [stateNameList, setStateNameList] = useState([]);
    const [defaultCityValue, setDefaultCityValue] = useState(props.defaultCityValue);
    const [cityName, setCityName] = useState(null);
    const [cityNameList, setCityNameList] = useState([]);
    const [zipcodeList, setZipcodeList] = useState([]);
    const [stateCityValidation] = useState(props?.stateCityValidation || "");


    const [searchZipcodeValue, setSearchZipcodeValue] = useState("");
    const [searchStatename, setSearchStatename] = useState("");
    const [searchCityname, setSearchCityname] = useState("");
    const [searchZipcodenameId, setSearchZipcodenameId] = useState("");
    const [zipCodeError, setZipCodeError] = useState("");
    const [flag, setFlag] = useState(false);

    async function fetchCountry() {
        const country = API.get('country');
        country.then(res => {
            setCountry(res.data.data[0].country_id);
        })
        .catch(function (error) {
            if (error.response) {
                props.setNewError(error.response.data.error, true)
                // setNewError(true)
            }
        });
    }

    async function fetchState(zipFlag) {
        let request = {
            country_id: 228,
        
        };
        const state = API.post('sellerregstate/condition', request);
        state.then(res => {
            setStateNameList(res.data.data);
            setCityName(null)
            setZipCodeId(null)
            if (zipFlag !== "zipSearchFlag") {
                setSearchZipcodenameId("")
                setSearchCityname("")
            }
            if(props.isEdit){
                res.data.data.filter(data=> {
                    console.log("data.state_name====",data.state_name)
                    console.log("props.defaultStateValue===",defaultStateValue)
                    if(data.state_name?.toLowerCase() === defaultStateValue ?.toLowerCase()){
                        setStateName(data.state_name)
                        fetchCity(data.state_id,zipFlag)
                    } 
                })
               
            }
        })
        .catch(function (error) {
            if (error.response) {
                props.setNewError(error.response.data.error, true)
                // setNewError(true)
            }
        });
    }

    function fetchCity(e,zipFlag) {
        let request = {
            state_id: e,
           
        };
        const state = API.post('sellerregcity/condition', request);
        state.then(res => {
            setCityNameList(res.data.data);
            setZipCodeId(null)
            if (zipFlag !== "zipSearchFlag") {
                setSearchZipcodenameId("")
                setSearchCityname("")
            }
            setFlag(true);
            if(props.isEdit){
                res.data.data.filter(data=> {
                    if(data.city_name?.toLowerCase() === defaultCityValue ?.toLowerCase()){
                        setCityName(data.city_name)
                        // setZipCodeId(null)
                        fetchZipcode(data.city_id)
                    }
                })
            }
        })
        .catch(function (error) {
            if (error.response) {
                props.setNewError(error.response.data.error, true)
                // setNewError(true)
            }
        });
    }
    function fetchZipcode(e) {
        let request = {
            city_id: e,
          
        };
        const state = API.post('sellerregzipcode/condition', request);
        state.then(res => {
            setZipcodeList(res.data.data);
            if(props.isEdit){
                res.data.data.filter(data=>{
                    data.zipcode == defaultZipcodeValue && setZipCodeId(data.zipcode)
                }
                    )
            }
        })
        .catch(function (error) {
            if (error.response) {
                props.setNewError(error.response.data.error, true)
                // setNewError(true)
            }
        });
    }

    useEffect(() => {
        if(!isEdit){
            stateNameList.length>0 && stateName ? props.setStateValue(stateNameList.filter(data=>data.state_name == stateName)[0]?.state_id || null,"") : props.setStateValue(null,"");
            cityNameList.length>0 && cityName ?  props.setCityValue(cityNameList.filter(data=>data.city_name==cityName)[0]?.city_id || null,"")  : props.setCityValue(null,"");
            zipcodeList.length>0 && zipCodeId ?  props.setZipcodeValue(zipcodeList.filter(data=>data.zipcode==zipCodeId)[0]?.zipcode_id || null) : props.setZipcodeValue(null);   
        } 
  
    }, [stateName, cityName, zipCodeId]);

    useEffect (()=>{
        if(isEdit){
            setDefaultStateValue(props.defaultStateValue);
            setDefaultCityValue(props.defaultCityValue);
            setDefaultZipcodeValue(props.defaultZipcodeValue); 
        }
    })
    
    useEffect(() => fetchCountry(),[])
    
    useEffect(() => {
        fetchState(); 
    }, [defaultStateValue]);

    
const cityAndZipReset=()=>{
    setCityName(null)
    setZipCodeId(null)
}

    const handleState = (e) => {
        setStateName( stateNameList.filter(data=>data.state_id == e.target.value)[0].state_name)
        console.log("state===",stateNameList.filter(data=>data.state_name == e.target.value)[0]?.state_id || null)
        props.isEdit && props.setStateValue(stateNameList.filter(data=>data.state_id == e.target.value)[0]?.state_id || null,"");
        props.isEdit && props.setCityValue(null,"");
        props.isEdit && props.setZipcodeValue(null);   
        // cityNameList.length === 0 ? fetchCity(e.target.value): cityAndZipReset()
        setCityNameList([])
        setZipcodeList([])
        fetchCity(e.target.value,"")
        setSearchZipcodeValue("")
        setZipCodeError("")

        console.log("handleState",searchZipcodeValue)
        // setCityName(null)
        // setZipCodeId(null)
    }

    const handleCity = (e) => {
        setCityName(cityNameList.filter(data=>data.city_id==e.target.value)[0].city_name)
        console.log("city===",cityNameList.filter(data=>data.city_name==e.target.value)[0]?.city_id || null)
        props.isEdit &&  props.setCityValue(cityNameList.filter(data=>data.city_id==e.target.value)[0]?.city_id || null,"");
        props.isEdit && props.setZipcodeValue(null);
        // zipcodeList.length === 0 && fetchZipcode(e.target.value)
        setZipcodeList([])
        fetchZipcode(e.target.value)
        setSearchZipcodeValue("")
        // setZipCodeId(null)
    }

    const handleZipcode = (e) => {
        setZipCodeId(zipcodeList.filter(data=>data.zipcode==e.target.value)[0].zipcode); 
        console.log("zip====",zipcodeList.filter(data=>data.zipcode==e.target.value)[0]?.zipcode_id || null)
        props.setZipcodeValue(zipcodeList.filter(data=>data.zipcode==e.target.value)[0]?.zipcode_id || null);
        setSearchZipcodeValue("")
    }

    const OnSearch = (e) => {
        setStateNameList([])
        setCityNameList([])
        setZipcodeList([])
        setZipCodeId(null)
        setCityName(null)
        setStateName(null)
        const value = e.target.value.replace(/\D/g, "");
        setSearchZipcodeValue(value);
        if (e.target.value.length === 0) {
            setZipCodeError("")
        }
    };

    const gitZipCodeSearch = (e) => {
        setZipCodeError("")

        let request = {
            zipcode: searchZipcodeValue,
            // seller_id:sellerDetails.seller_id ? sellerDetails.seller_id : "",
            // seller_token:sellerDetails.seller_token ? sellerDetails.seller_token:"",
        }
        API.post("getplace/condition", request).then(response => {
            if (response.data.data?.length > 0) {
                props.setZipcodeValue(response.data?.data[0]?.zipcode)
                props.setCityValue(response.data?.data[0]?.city, "searchCity")
                props.setStateValue(response.data?.data[0]?.administrativeLevels?.level1long, "searchState")

                setSearchZipcodenameId(response.data?.data[0]?.zipcode)
                setSearchCityname(response.data?.data[0]?.city)
                setSearchStatename(response.data?.data[0]?.administrativeLevels?.level1long)
                fetchState("zipSearchFlag")
            }
            else {
                props.setZipcodeValue(null)
                props.setCityValue(null, "")
                props.setStateValue(null, "")
                setSearchZipcodenameId("")
                setSearchCityname("")
                setSearchStatename("")
                fetchState("zipSearchFlag")
                setZipCodeError("Invalid Zipcode")
            }
        })
    }

    const onKeydownZipcodeSearch = (event) => {
        if (event.key === "Enter") {
            // console.log("Enter is pressed call search function");
            gitZipCodeSearch();
        }
    };

    useEffect(() => {
        if (searchZipcodeValue !== "") {
            const timer = setTimeout(() => {
                gitZipCodeSearch();
            }, 1000);
            return () => {
                clearTimeout(timer);
            }
        }
        else{
            fetchState("zipSearchFlag")

        }
    }, [searchZipcodeValue]);


return (
    <>
        <div className="col-sm-6 form-group selectTbox">
            <div className="tbox">                
                <div className="selcetclass"> 
                    <select className="form-control custom-select browser-default textbox"  defaultValue={stateName}  onChange={handleState}>
                        <option value={null} style={{"display":"none"}}>{searchStatename}</option>
                        {stateNameList.length>0 &&
                            <>
                                {stateNameList.map((state, index) => <option key={state.state_id} value={state.state_id} selected = { isEdit ?  state.state_name === defaultStateValue ? true : false : false} >{state.state_name}</option>)}
                            </>
                        }
                    </select>
                    {props?.stateCityValidation === "1" && <p className="form-input-error" >State is required</p>}

                    <label  htmlFor="state_id" className={"input-has-value required"}>State</label>
                    </div>
            </div>
        </div>
        <div className="col-sm-6 form-group selectTbox">
            <div className="tbox">              
                <div className="selcetclass"> 
                    <select id="City" className="form-control custom-select browser-default textbox"  defaultValue={cityName} onChange={handleCity}>
                    <option value={null} style={{"display":"none"}}>{searchCityname}</option>
                        {cityNameList.length>0 &&
                            <>
                                {cityNameList.map((city, index) => <option key={city.city_id} value={city.city_id} selected = { isEdit ?  city.city_name === defaultCityValue ? true : false : false} >{city.city_name}</option>)}
                            </>
                        }
                    </select>
                    {props?.stateCityValidation === "2" && <p className="form-input-error" >City is required</p>}

                    <label  htmlFor="city_id" className={"input-has-value required"}>City</label>
                </div>                   
            </div>
        </div>
        <div className="col-sm-6 form-group selectTbox">
            <div className="tbox">        
                <div className="selcetclass"> 
                    <select id="zipcode_id" className="form-control custom-select browser-default textbox"  defaultValue={zipCodeId} onChange={handleZipcode}>
                    <option value={null} style={{"display":"none"}}>{searchZipcodenameId}</option>
                        {zipcodeList.length>0 &&
                            <>
                                {zipcodeList.map((zipcode, index) => <option key={zipcode.zipcode_id} value={zipcode.zipcode} selected = { isEdit ?  zipcode.zipcode === defaultZipcodeValue ? true : false : false} >{zipcode.zipcode}</option>)}
                            </>
                        }
                    </select>
                    {props?.stateCityValidation === "3" && <p className="form-input-error" >Zipcode is required</p>}

                    <label  htmlFor="zipcode_id" className={"input-has-value required"}>Zipcode</label>
                </div>                   
            </div>
        </div>
        {/* <div style={{"position": "absolute","top": "76%", "left": "51%" }} >or</div> */}
        <div className="col-sm-6 form-group">
                <div className="tbox">

                <input type="text"  className="form-control textbox" placeholder="" 
                onKeyDown={onKeydownZipcodeSearch}  name="z-search" id="zipsearch-id"
                onChange={OnSearch} value={searchZipcodeValue}/* onBlur={(e) => setAddress(e.target.value)} */ />
                 {/* <label htmlFor="address" className="input-has-value">Zipcode</label> */}
                 <label for="zipsearch-id"className={searchZipcodeValue != "" ? "input-has-value required" : ""}>Zipcode</label>
                    {/* <label for="zipcode" className="form-label">Zipcode</label>
                    <input
                        type="text"
                        class="form-control"
                        id="billofsale"
                        onKeyDown={onKeydownZipcodeSearch}
                        onChange={OnSearch}
                    /> */}
                    <p className="form-input-error" >{zipCodeError}</p>
                </div>
            </div>
    </>
)}

export default StateAndCityRegistration;